import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7505fec2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "switch tw-relative tw-inline-block tw-min-w-[40px]"
};
var _hoisted_2 = ["data-cy", "checked"];
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "slider round peer-checked/toggle:tw-bg-w-primary tw-absolute tw-cursor-pointer tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-bg-w-lavender tw-duration-300 before:tw-rounded-circle before:tw-shadow-sm before:tw-content-[''] before:tw-absolute before:tw-h-[22px] before:tw-w-[22px] before:tw-left-0 before:tw-bottom-0 before:tw-border before:tw-border-w-secondary before:tw-border-solid before:tw-bg-white before:tw-duration-300"
  }, null, -1 /* HOISTED */);
});
var _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["switch-container tw-inline-block tw-items-center", _ctx.$attrs['class']])
  }, [_renderSlot(_ctx.$slots, "leftLabel", {}, undefined, true), _createElementVNode("label", _hoisted_1, [_createElementVNode("input", {
    "data-cy": (_a = _ctx.$attrs['data-cy']) !== null && _a !== void 0 ? _a : '',
    "class": "tw-opacity-0 tw-w-0 tw-h-0 tw-peer/toggle",
    type: "checkbox",
    checked: _ctx.modelValue,
    onInput: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return _ctx.handleToggle($event);
    }, ["stop"]))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), _hoisted_3]), _ctx.withRightLabel ? _renderSlot(_ctx.$slots, "rightLabel", {
    key: 0
  }, function () {
    return [_createElementVNode("span", {
      "class": "tw-ml-10px",
      innerHTML: _ctx.label
    }, null, 8 /* PROPS */, _hoisted_4)];
  }, true) : _createCommentVNode("v-if", true)], 2 /* CLASS */);
}